import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmpts-stepperdetail',
  templateUrl: './stepperdetail.component.html',
  styleUrls: ['./stepperdetail.component.css']
})
export class StepperdetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
